import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import ControlTitle from "../ControlTitle";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import _ from "lodash";

class LookupText extends Component {
  constructor() {
    super();
    this.state = {
      input: false
    };
  }
  shouldComponentUpdate(nextProps) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.lookup !== nextProps.lookup ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;

    const { lookup, ...formControl } = nextProps;

    let repeatingFormUUID = formControl.repeatingFormUUID;
    let lookupItem = null;

    if (repeatingFormUUID !== undefined) {
      lookupItem = _.filter(lookup, function(item) {
        return (
          item.parentId === Number(formControl.element_parent) &&
          item.repeatingFormUUID === repeatingFormUUID
        );
      });
    } else {
      lookupItem = _.filter(lookup, function(item) {
        return item.parentId === Number(formControl.element_parent);
      });
    }

    let val = "";
    if (lookupItem.length > 0) {
      val = lookupItem[0][formControl.element_params.Fk];
      if (val === undefined) {
        val = "";
      }
    }
    if (
      this.props.element_value !== val &&
      (!this.state.input || this.props.lookup !== nextProps.lookup)
    ) {
      this.props.onChange(this.props.repeatingForm, this.props.element_id, val);
    }

    return different;
  }

  handleChange(e) {
    this.setState({ input: true });
    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      e.target.value
    );
  }

  renderInput() {
    const {
      element_value,
      element_readonly,
      validate,
      error,
      ...formControl
    } = this.props;
    var maxLength = formControl.element_params.H;

    if (validate && error) {
      return (
        <input
          className="error"
          maxLength={maxLength}
          value={element_value}
          onChange={this.handleChange.bind(this)}
        />
      );
    }

    return (
      <input
        readOnly={element_readonly === "1" ? true : false}
        value={element_value}
        maxLength={maxLength}
        onChange={this.handleChange.bind(this)}
      />
    );
  }

  render() {
    const { element_prompt, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          <div>{this.renderInput()}</div>
        </Form.Field>
      </div>
    );
  }
}

LookupText.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  lookup: state.form.lookup
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LookupText);



// WEBPACK FOOTER //
// ./src/components/LookupText/index.js